<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/gate_tef.jpeg')"
      >
      </parallax>
      <div class="container">
        <h3 class="title mt-5">{{ $t('aboutUs.hero.title') }}</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">

     <!--  <h3 class="mb-4 font-weight-bold">
        <img
          src="img/icon/icon 2 (7).png" alt=""
          width="4%"
          class="ml-3 mr-3"
        /> <span style="color: #008c45;">About Us</span></h3> -->
      <div class="row mt-5">
        <div class="col-md-10 col-xl-6 text-center">
          <img
            src="img/discovery_about.jpg"
            alt="PT TEF company information"
            class="rounded animated fadeInDown"
            height="70%"
          />
          <h6 class="text-left mt-4">
            {{ $t('aboutUs.companyInfo.dateEstablished') }}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; 16 April 2019  <br>
            {{ $t('aboutUs.companyInfo.capital') }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; IDR. 120,000,000,000 <br>
            {{ $t('aboutUs.companyInfo.shareholder') }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp; TOKKI LTD (99.9%), OKADA SANGYO CO., LTD (0.1%) <br>
            {{ $t('aboutUs.companyInfo.presidentDirector') }}  &nbsp;:&nbsp; Ryohichi Yunomae <br>
            {{ $t('aboutUs.companyInfo.totalEmployee') }}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp; 174 <br>
            {{ $t('aboutUs.companyInfo.bank') }}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp; MUFG Bank, Ltd, Jakarta Branch <br>
            {{ $t('aboutUs.companyInfo.emailAddress') }}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : sales@tef.co.id <br>
          </h6>
        </div>
        <div class="col-md-10 col-xl-6 text-left align-middle">
          <h2 class="font-weight-bold align-middle tefGreen">
            PT TOKKI ENGINEERING AND FABRICATION
          </h2>
            <!-- Company Overview (Shown by default) -->
            <button class="collapse-btn" type="button" data-toggle="collapse" data-target="#overviewCollapse" aria-expanded="false" aria-controls="overviewCollapse">
              <span><span class="icon-section">&#10138;</span> {{ $t('aboutUs.overview.toggleLabel') }}</span>
              <span class="collapse-toggle-icon"></span>
            </button>
            <div class="collapse collapse-content" id="overviewCollapse">

            </div>
            <div class="card-custom card-body mt-3 text-dark" style="background-color: #f2f2f2; font-family: Arial, sans-serif;">
              <h5>
                <!-- Content goes here -->
                <span v-html="$t('aboutUs.overview.paragraph1')"></span>
                <span v-html="$t('aboutUs.overview.paragraph2')"></span>
              </h5>
            </div>
        </div>
      </div>

      <!-- Our Specialization -->
      <button class="collapse-btn mt-5" type="button" data-toggle="collapse" data-target="#specializationCollapse" aria-expanded="false" aria-controls="specializationCollapse">
        <span><span class="icon-section">&#10138;</span> {{ $t('aboutUs.specialization.toggleLabel') }}</span>
        <span class="collapse-toggle-icon">+</span>
      </button>
      <div class="collapse collapse-content" id="specializationCollapse">
        <div class="card-custom card-body text-dark" style="background-color: #f2f2f2; font-family: Arial, sans-serif;">
          <!-- Content goes here -->
          <h5 v-html="$t('aboutUs.specialization.paragraph')"></h5>
        </div>
      </div>

      <!-- Our Values -->
      <button class="collapse-btn" type="button" data-toggle="collapse" data-target="#valuesCollapse" aria-expanded="false" aria-controls="valuesCollapse">
        <span><span class="icon-section">&#10138;</span> {{ $t('aboutUs.values.toggleLabel') }}</span>
        <span class="collapse-toggle-icon">+</span>
      </button>
      <div class="collapse collapse-content" id="valuesCollapse">
        <div class="card-custom card-body text-dark" style="background-color: #f2f2f2; font-family: Arial, sans-serif;">
          <!-- Content goes here -->
          <h5>
          <b>{{ $t('aboutUs.values.item1.title') }}</b> <br>
          {{ $t('aboutUs.values.item1.desc') }} <br><br>
          <b>{{ $t('aboutUs.values.item2.title') }}</b> <br>
           {{ $t('aboutUs.values.item2.desc') }} <br><br>
          <b>{{ $t('aboutUs.values.item3.title') }}</b> <br>
           {{ $t('aboutUs.values.item3.desc') }} <br><br>
          <b>{{ $t('aboutUs.values.item4.title') }}</b> <br>
           {{ $t('aboutUs.values.item4.desc') }} <br><br>
          <b>{{ $t('aboutUs.values.item5.title') }}</b>
           {{ $t('aboutUs.values.item5.desc') }}
           </h5>
        </div>
      </div>

      </div>

      <!-- <div class="container">
        <div class="row mt-5">
          <div class="col-md-10 col-xl-6 text-left">
            <h3 class="font-weight-bold text-left align-middle">
               <span style="color: green;">[Vision]</span>
            </h3>
            <span class="text-left mt-n3">
              We bring together Mastery Meets Innovation to solve corrosion issues and other process industry problems in one place. We aim to become a trusted, one-stop leading fabricator that gives everyone peace of mind.
            </span>

            <h3 class="font-weight-bold text-left align-middle mt-5">
               <span style="color: green;">[Mission]</span>
            </h3>
            <span class="text-left mt-n3">
              We build strong trust and create new possibilities in the process industry with mastery, innovation, a passion for challenges, and honesty. 
              We combine craftsmanship with advanced technology to provide high-quality products and services. <br>
              Our goal is to ensure stable operations and peace of mind for our customers while continuously bringing new value to their businesses. 
              We embrace challenges and drive change with passion. By doing so, we shape an exciting future that inspires the process industry and leads to continuous 
            </span>
          </div>
          <div class="col-md-10 col-xl-6 text-left align-middle mt-4">
            <img
              src="img/organization_chart.png"
              class="rounded animated fadeInDown"
            />
          </div>
        </div>
      </div> -->

      <div class="section section-tabs mt-5">
        <div class="container">

          <h2>
            <img
              src="img/icon/icon.png" alt=""
              width="4%"
              class="ml-3 mr-3"
            /> {{ $t('aboutUs.visionMission.heading') }}
          </h2>

          <!-- Vision Card -->
          <div class="card">
            <div class="card-header">
              <div class="icon-circle">
                <i class="fas fa-eye"></i>
              </div>
              <h3>{{ $t('aboutUs.visionMission.vision.title') }}</h3>
            </div>
            <div class="card-content">
              <ul>
                <li><h5> {{ $t('aboutUs.visionMission.vision.item1') }} </h5></li>
                <li><h5> {{ $t('aboutUs.visionMission.vision.item2') }} </h5></li>
              </ul>
            </div>
          </div>

          <!-- Mission Card -->
          <div class="card">
            <div class="card-header">
              <div class="icon-circle">
                <i class="fas fa-bullseye"></i>
              </div>
              <h3>{{ $t('aboutUs.visionMission.mission.title') }}</h3>
            </div>
            <div class="card-content">
              <ul>
                <li><h5>{{ $t('aboutUs.visionMission.mission.item1') }} </h5></li>
                <li><h5>{{ $t('aboutUs.visionMission.mission.item2') }} </h5></li>
                <li><h5>{{ $t('aboutUs.visionMission.mission.item3') }} </h5></li>
              </ul>
            </div>
          </div>

          <h3 class="mb-4 font-weight-bold mt-5">
            <img
              src="img/icon/icon (3).png" alt=""
              width="4%"
              class="ml-3 mr-3"
            /> <span style="color: #008c45;">{{ $t('aboutUs.qualityPolicy.heading') }}</span>
          </h3>

          <div style="font-family: Arial, sans-serif;">
          <h3 class="font-weight-bold mb-1">{{ $t('aboutUs.qualityPolicy.commitmentTitle') }}</h3>
          <h5 v-html="$t('aboutUs.qualityPolicy.commitmentDesc')"></h5>

          <h4 class="font-weight-bold mb-1">{{ $t('aboutUs.qualityPolicy.ourCommitmentsHeading') }}</h4>
          <h5>{{ $t('aboutUs.qualityPolicy.commitment1') }}</h5>
          <h5 class="mt-n3">{{ $t('aboutUs.qualityPolicy.commitment2') }}</h5>
          <ul>
            <li><h5> {{ $t('aboutUs.qualityPolicy.deliverList.item1') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.deliverList.item2') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.deliverList.item3') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.deliverList.item4') }} </h5></li>
          </ul>

          <h4 class="font-weight-bold mb-1">{{ $t('aboutUs.qualityPolicy.accountabilityHeading') }}</h4>
          <ul>
            <li><h5>{{ $t('aboutUs.qualityPolicy.accountabilityList.item1') }} </h5></li>
            <li><h5 class="mt-n3">{{ $t('aboutUs.qualityPolicy.accountabilityList.item2') }} </h5></li>
            <li><h5 class="mt-n3">{{ $t('aboutUs.qualityPolicy.accountabilityList.item3') }} </h5></li>
          </ul>

          <h4 class="font-weight-bold mb-1">{{ $t('aboutUs.qualityPolicy.structureHeading') }}</h4>
          <ul>
            <li><h5> {{ $t('aboutUs.qualityPolicy.structureList.item1') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.structureList.item2') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.structureList.item3') }} </h5></li>
            <li><h5 class="mt-n3"> {{ $t('aboutUs.qualityPolicy.structureList.item4') }} </h5></li>
          </ul>
          </div>
          
        <!-- <div class="row mt-n4">
          <div class="col-md-10 col-xl-6 text-left">
            <h3 class="font-weight-bold text-left align-middle">
               <span style="color: green;">[Vision]</span>
            </h3>
            <span class="text-left mt-n3">
              We bring together Mastery Meets Innovation to solve corrosion issues and other process industry problems in one place. <br>
              We aim to become a trusted, one-stop leading fabricator that gives everyone peace of mind.
            </span>

            <h3 class="font-weight-bold text-left align-middle mt-5">
               <span style="color: green;">[Mission]</span>
            </h3>
            <span class="text-left mt-n3">
              We build strong trust and create new possibilities in the process industry with mastery, innovation, a passion for challenges, and honesty. 
              We combine craftsmanship with advanced technology to provide high-quality products and services. <br>
              Our goal is to ensure stable operations and peace of mind for our customers while continuously bringing new value to their businesses. <br>
              We embrace challenges and drive change with passion. <br>
              By doing so, we shape an exciting future that inspires the process industry and leads to continuous growth and innovation. <br>
              This is the mission of TEF.
            </span>
          </div>
          <div class="col-md-10 col-xl-6 text-left align-middle mt-4">
            <img
              src="img/new_organization.png"
              class="rounded animated fadeInDown"
            />
          </div>
        </div> -->
      </div>
      </div>


      <img src="img/milestone/website design (42).png" alt="" class=" img-fluid mt-n4 " />
      <div class="container-fluid">
      <!-- <h3 class="mb-4 font-weight-bold mr-" style="margin-top: -150px;">
        <img
          src="img/milestone/website design.png"
          width="4%"
          class="ml-3 mr-3"
        /> <span style="color: white;">Our Company Milestones</span>
      </h3> -->
        
      </div>
      </div>

      <img src="img/milestone/website design (3).png" alt="TEF company milestones" class=" img-fluid mt-0 mb-5"/>
      <el-carousel style="margin-bottom: 200px;">
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (4).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (5).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (8).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (9).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (10).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (11).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (12).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (13).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (14).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (15).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (16).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (17).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (18).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (19).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (20).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (21).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (22).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (23).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (24).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (25).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (27).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (28).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (29).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (30).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (31).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (32).png" alt="First slide" />
            </div>
            <div  class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (33).png" alt="First slide" width="300px;"/>
            </div>
            <div  class="col-lg-3 mt-5">
              <img class="d-block" src="img/milestone/website design (34).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="row justify-content-center ">
            <div class="col-lg-2">
              <img class="d-block" src="img/milestone/website design (35).png" alt="First slide" width="300px;" />
            </div>
            <div  class="col-lg-3">
              <img class="d-block mt-5" src="img/milestone/website design (36).png" alt="First slide" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    
    <div class="section section-tabs text-center mt-5">
        <h3 class="font-weight-bold">{{ $t('aboutUs.parentCompany.heading') }}</h3>
        <img
          src="img/tokki_ltd.jpg"
          alt="Tokki Ltd Japan"
          class="rounded"
        />
        <h6 class="text-lowercase mt-3">
          {{ $t('aboutUs.parentCompany.desc1') }} <br>
          {{ $t('aboutUs.parentCompany.desc2') }}<br>
          <a href="http://www.tokkiltd.co.jp" target="_BLANK" style="color: green">http://www.tokkiltd.co.jp</a>
        </h6>
      </div>
    <!-- <div class="section section-tabs text-center">
      <div class="container">
        <h2 class="title">Our Team</h2>
        <h4>We are a team of creatives people innovation</h4>
        <div class="team">
          <div class="row mt-5">
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Mamad Saepulloh</h4>
                <p class="category text-success">Production</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Qodratulloh</h4>
                <p class="category text-success">Engineering/Design</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/fitri.jpeg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Fitri Hayati</h4>
                <p class="category text-success">Cost Control</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <img
                  src="img/default-avatar.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Subandi</h4>
                <p class="category text-success">Project Control</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// import { Tabs, TabPane } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  }
};
</script>
<style scoped>
  .parallax-about {
    /* The image used */
    background-image: url('/img/milestone/website design (1).png');

    /* Set a specific height */
    min-height: 400px;

    /* Create the parallax scrolling effect */
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }
</style>

 <style scoped>
    body {
      background-color: #f2f2f2;
    }

    .card-custom {
      background-color: #008c45;
      color: white;
      border-radius: 25px;
      padding: 20px;
    }

    .collapse-btn {
      background-color: #00994d;
      color: white;
      font-weight: bold;
      border-radius: 30px;
      margin-top: 15px;
      padding: 10px 20px;
      text-align: left;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .collapse-btn:focus {
      outline: none;
      box-shadow: none;
    }

    .collapse-btn:hover {
      background-color: #007f3f;
      color: white;
    }

    .collapse-content {
      margin-top: 10px;
    }

    .icon-section {
      margin-right: 10px;
    }

    .collapse-toggle-icon {
      font-size: 1.5rem;
    }
  </style>

  <!-- vission mission -->
  <style scoped>
    body {
      font-family: Arial, sans-serif;
      background-color: #e0e0e0;
    }

    h2 {
      color: #007a3d;
      display: flex;
      align-items: center;
      font-size: 1.8rem;
    }

    h2 i {
      margin-right: 10px;
      font-size: 1.8rem;
    }

    .card {
      background-color: white;
      border-radius: 25px; /* Rounded lebih besar */
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
      padding: 25px;
      margin-top: 20px;
    }

    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .icon-circle {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: #d58e24;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      flex-shrink: 0;
    }

    .icon-circle i {
      color: white;
      font-size: 22px;
    }

    .card-header h3 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: bold;
    }

    .card-content ul {
      padding-left: 1rem;
      margin-top: 10px;

    }

    .card-content ul li {
      margin-bottom: 10px;
    }

    /*untuk layar device berukuran kecil*/
    @media (max-width: 360px) {
      .tefGreen {
        margin-top: 80px; /* contoh: lebih ke atas */
      }
    }

    /*untuk layar device berukuran sedang*/
    @media screen and (min-width: 550px) {
       .tefGreen {
          margin-top: -80px; /* contoh: lebih ke atas */
      }
    }

    /*untuk layar device berukuran besar*/
    @media screen and (min-width: 800px) {
       .tefGreen {
          margin-top: 0px; /* contoh: lebih ke atas */
      }
    }
  
.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
